const tmLogger = {
    eventCategory: '',
    eventAction: '',
    eventLabel: '',
    eventValue: '',
    setEventCategory: function(category) {
        this.eventCategory = category;
    },
    setEventAction: function(action) {
        this.eventAction = action;
    },
    setEventLabel: function(label) {
        this.eventLabel = label;
    },
    setEventValue: function(value) {
        this.eventValue = value;
    },
    sendEvent: function(name) {
        $.ajax({
            url: _d.url.tmEvents,
            type: 'POST',
            data: {
                eventName: name,
                eventCategory: this.eventCategory,
                eventAction: this.eventAction,
                eventLabel: this.eventLabel,
                eventValue: this.eventValue
            }
        });
    }
};
